import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Client } from 'src/app/shared/models/client';
import { Family } from 'src/app/shared/models/family';
import { HSABankRequestObject } from 'src/app/shared/models/hsabank-request-object';
import { Spouse } from 'src/app/shared/models/spouse';
import { FormService } from 'src/app/shared/services/form.service';

import { saveAs } from 'file-saver';

import { filter } from 'rxjs/operators';
import { Condition, Gender } from 'src/app/shared/enums';
import { UserService } from 'src/app/shared/services/user.service';
import { Global } from 'src/app/shared/global';

const MaritalStatus = {
  1: 'Single',
  2: 'Married',
  3: 'Divorced/Widowed'
  // 4: 'Widow'
}

@Component({
  selector: 'app-slider-container',
  templateUrl: './slider-container.component.html',
  styleUrls: ['./slider-container.component.scss']
})
export class SliderContainerComponent implements OnInit {
  client: Client = {} as Client;
  clientGenderStr: string;
  clientHealthConditions: string[];
  yearOneRetirement: number;
  taxPercentage: number;

  spouse: Spouse = {} as Spouse;
  spouseGenderStr: string;
  spousehealthConditions: string[];

  family: Family = {} as Family;
  clientHSADetails: any = {};
  outOfPocket: number = 0;
  requestObject: HSABankRequestObject = {} as HSABankRequestObject;

  isClientVisible: boolean;
  isSpouseVisible: boolean;
  isFamilyVisible: boolean;
  isDependentsVisible: boolean;
  isHealthcareCostsVisible: boolean;
  isHSABalanceVisible: boolean;
  isHSAInvestmentVisible: boolean;
  isRetirementYearOneVisible: boolean;
  
  maritalStatus: string;
  showMobile: boolean = false;
  showMenu: boolean = false;
  activeRoute: string = '';

  myInnerHeight: string;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window.innerWidth < 767) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }

    let rightContainerElement = document.getElementById('RightContainer');
    let rightContainerHeight = rightContainerElement.scrollHeight;

    if (window.location.toString().includes('results')) {
      // if (window.innerWidth < 1280) {
      //   this.myInnerHeight = Number(rightContainerHeight + 75).toString();
      // } else {
      //   this.myInnerHeight = Number(rightContainerHeight).toString();
      // }
      this.myInnerHeight = Number(rightContainerHeight + 75).toString();
    }
  }

  constructor(private router: Router, private formService: FormService, private userService: UserService, public global: Global, private elementRef: ElementRef) {
    if (window.innerWidth < 767)
      this.showMobile = true;

    this.formService.clientObject.subscribe(form => {
      this.client = { ...form.value };
      this.clientGenderStr = Gender[this.client.gender];
      this.clientHealthConditions = this.client.healthConditions ? this.client.healthConditions.map((condition) => Condition[condition]) : [''];
      this.maritalStatus = MaritalStatus[this.client.maritalStatus]
    });

    this.formService.spouseObject.subscribe(form => {
      this.spouse = { ...form.value };
      this.spouseGenderStr = Gender[this.spouse.gender];
      this.spousehealthConditions = this.spouse.healthConditions ? this.spouse.healthConditions.map((condition) => Condition[condition]) : [''];

      if (this.spouse && this.spouse.currentAge > 0)
        this.isSpouseVisible = true;
      else 
        this.isSpouseVisible = false;
    });

    this.formService.familyObject.subscribe(form => {
      this.family = { ...form.value };
      if (router.url.includes('/my-family/dependents-age')){
        this.isDependentsVisible = true;
        this.isFamilyVisible = true;
      }

      if (router.url.includes('/my-family')){
        this.isDependentsVisible = this.family.dependents && this.family.dependents.length > 0;
      }

      if (this.family.spouse && this.family.spouse.currentAge > 0)
        this.isSpouseVisible = true;

      if (this.family.included)
        this.isFamilyVisible = true;
      else
        this.isFamilyVisible = false;
    });

    this.formService.preRetirementObject.subscribe(form => {
      this.outOfPocket = { ...form.value }.outOfPocket;
      let modifiedValue = { ...form.value }.modifiedValue;
      this.outOfPocket = modifiedValue > 0 ? modifiedValue : { ...form.value }.outOfPocket;
      //let currentYear = new Date().getFullYear();
      //this.yearOneRetirement = currentYear + Math.max(0, this.client.retirementAge - this.client.currentAge);
    });

    this.formService.inRetirementObject.subscribe(form => {
      this.yearOneRetirement = { ...form.value}.firstYearRetirementCosts;
    });

    this.formService.clientHSADetailsObject.subscribe(form => {
      this.clientHSADetails = { ...form.value };      
    });

    this.formService.requestObject.subscribe((form => {
      this.requestObject = { ...form.value };
    }));

    this.formService.resultsResponseObject.subscribe((results) => {
      this.taxPercentage = results.taxBracketPercent ? results.taxBracketPercent.toFixed(2) : 0.00;
    });

    router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      this.activeRoute = event['url']; //router.url 
      //let rightContainerElement = document.getElementById('RightContainer');
      //let rightContainerHeight = rightContainerElement.clientHeight;

      // if (window.innerWidth < 1280) {
      //   this.myInnerHeight = !this.myInnerHeight ? (rightContainerHeight + 75).toString() : this.myInnerHeight;
      // } else {
      //   this.myInnerHeight = !this.myInnerHeight ? rightContainerHeight.toString() : this.myInnerHeight;
      // }
      
      if (this.activeRoute.includes('/retirement-costs')) { 
        this.isHealthcareCostsVisible = true;
        this.isDependentsVisible = this.family.dependents && this.family.dependents.length > 0;
      }

      if (this.activeRoute.includes('/whats-next') && this.showMobile) {
        this.isClientVisible = false;
      }

      if (this.activeRoute.includes('/my-family') && this.family.included) {
        this.isClientVisible = true;
      }

      if (this.activeRoute.includes('/pre-retirement-costs') && !this.family.included) {
        this.isClientVisible = true;
      }
      if (this.activeRoute.includes('/results') && this.showMobile) {
        this.isClientVisible = true;
      }

      /* if (event['url'] === '/my-family' || event['url'] === '/my-family/dependents' || event['url'] === '/my-family/dependents-age') { 
        this.isDependentsVisible = this.family.dependents && this.family.dependents.length > 0;
      } */

      if (this.activeRoute.includes('/hsa-information')) {
        this.isRetirementYearOneVisible = true;
      }

      if (this.activeRoute.includes('/hsa-investment')) {
        this.isHSABalanceVisible = true;
      }

      if (this.activeRoute.includes('/results')) {
        this.isHSAInvestmentVisible = true;
      }
    });

  }

  expandMenu() {
    var menu = this.elementRef.nativeElement.querySelector('.main-container');
    this.showMenu = !this.showMenu;
    
    // if (this.showMenu) {
    //   menu.classList.add('close-menu');
    //   menu.classList.remove('open-menu');
    //   this.elementRef.nativeElement.setAttribute('style', 'height: 100%!important');
    // } else {
    //   this.elementRef.nativeElement.setAttribute('style', 'height: 10%!important');
    //   menu.classList.remove('close-menu');
    //   menu.classList.add('open-menu');
    // }
  }

  ngOnInit(): void {
  }

  directUserToForm(route: String) {
    if(this.showMobile){
      this.showMenu = false;
    }

    //this.router.navigateByUrl(`/${route}`);
    this.router.navigate([`/${route}`], { queryParams: { org: this.global.orgID } });
  }

  formatCondition(condition: string) {
    condition = typeof condition == 'number' ? Condition[condition] : condition;
    return condition == 'NoDiseases' ? 'No Disease' : condition.replace('_', ' ').replace('_', ' ')
  }

  formatGender(gender: string) {
    if (gender)
      return gender.split('_').join(' ');
  }

  // getReport() {
  //   this.global.loading = true;

  //   let headers = new Headers({ 
  //     'Accept': 'application/pdf',
  //   });

  //   this.userService.getPDF(Global.BASE_URL + Global.GET_HSA_PDF, this.formService.getRequestObject()).subscribe((resp) => {
  //     let reportName = 'Personalized HSA Report';
  //     saveAs(resp, reportName + ".pdf");

  //     this.formService.hasDownloadedPDF = true;
  //     this.global.loading = false;
  //   })
  // }

  kFormatter(num) {
    return Math.abs(num) > 999 ? Math.sign(num) * Math.round(Math.abs(num)/100)/10 + 'k' : Math.sign(num)*Math.abs(num);
  }
}
